import { raiseGAEvent, GA_EVENTS } from './analytics';
/**
 * Utility function to check if the group has sizes.
 */
export function checkProductIncludeSizes(groupName) {
  let hasSize = false;
  switch (groupName) {
    case 'CUSHION':
      hasSize = false;
      break;
    case 'GIFT':
      hasSize = false;
      break;
    case 'DECORATE':
      hasSize = false;
      break;
    default:
      hasSize = true;
  }
  return hasSize;
}

/**
 * Utility function to check if the product has accessories.
 */
export function checkProductIncludeAccessories(groupName) {
  let hasAccessories = false;
  switch (groupName) {
    case 'QUILTS ':
      hasAccessories = true;
      break;
    case 'BEDLINEN':
      hasAccessories = true;
      break;
    default:
      hasAccessories = false;
  }
  return hasAccessories;
}

/**
 * Utility function to check if the product has colors.
 */
export function checkProductIncludeColours(groupName) {
  let hasColours = true;
  switch (groupName) {
    case 'BATHROOM':
      hasColours = false;
      break;
    case 'BATHMAT':
      hasColours = false;
      break;
    case 'GIFT':
      hasColours = false;
      break;
    case 'FURNITURE':
      hasColours = false;
      break;
    default:
      hasColours = true;
  }
  return hasColours;
}

/**
 * Send closest inStock, lowStock, outStock store details into Google analytics.
 */
export function setAnalyticsStoreinfo(closestStoresArray, stockByStores) {
  let isClosestInStoreStoreFound = false;
  let isClosestLowStockStoreFound = false;
  let isClosestNoStockStoreFound = false;

  closestStoresArray.map(store => {
    const storeStock = stockByStores[store.rms_store_code];
    if (!storeStock) {
      return;
    }
    const storeDataForEvent = JSON.stringify({ id: store.id, name: store.name });
    if (!isClosestInStoreStoreFound && storeStock.inStock.length > 0) {
      isClosestInStoreStoreFound = true;
      raiseGAEvent(GA_EVENTS.CLOSEST_STORE_WITH_STOCK, storeDataForEvent);
    }

    if (!isClosestLowStockStoreFound && storeStock.lowStock.length > 0) {
      isClosestLowStockStoreFound = true;
      raiseGAEvent(GA_EVENTS.CLOSEST_STORE_LOW_STOCK, storeDataForEvent);
    }

    if (!isClosestNoStockStoreFound && storeStock.noStock.length > 0) {
      isClosestNoStockStoreFound = true;
      raiseGAEvent(GA_EVENTS.CLOSEST_STORE_NO_STOCK, storeDataForEvent);
    }
  });
}

/**
 * Utility function to validate postcode and suburb.
 */
 export function isValidPostCodeOrSuburb(postCode, countryCode){
  
  let postCodeRegEx = /\b\d{4}\b/g;

  if (countryCode.toLowerCase() === 'sg' ) {
    postCodeRegEx = /\b\d{4}(?:\d{2})?\b/g; // Singapore postcode is either 4 (old format) or 6 (new format) digits
  }

  let suburbRegEx = /(^(?=.{0,50}$)(?=.+[a-zA-Z\s])[a-zA-Z\s]+$)/gm;
  return postCodeRegEx.test(postCode) || suburbRegEx.test(postCode);
 }
 
 /**
 * Utility function to set label as sizes or items.
 */
 export function setFormLabelForItems(groupName){
  let label = 'Items';
  switch (groupName) {
    case 'QUILTS':
      label = 'Sizes';
      break;
    case 'BEDLINEN':
      label = 'Sizes';
      break;
    case 'TOWELS':
      label = 'Sizes';
      break;
    case 'HAND TOWELS':
      label = 'Sizes';
      break;
    case 'BATH TOWELS':
      label = 'Sizes';
      break;
    default:
      label = 'Items';
  }
  return label;
 }
 
export function getCountryCode(){
  let countryCode = 'au'; // default
  try {
      countryCode = document.querySelector('[data-block="country-selector"]')
                      .querySelector('[data-js="current-country"]').dataset.countryCode;
  } 
  catch (e) {
      console.error("Problem selecting current country");
  }
  return countryCode;
}

export function getCountry(){
  let countryCode = getCountryCode()
  
  switch (countryCode.toLowerCase()){
      case "au":
          return 'Australia';
          break;
      case "nz":
          return 'New Zealand';
          break;
      case "sg":
          return 'Singapore';
          break;
      default:
          return 'Australia';
          break;
  };
}
